
    var riot = require('riot')
    
import marked from "marked"
riot.tag2('riot-md', '', '', '', function(opts) {
    var self = this
    marked.setOptions({
      breaks: true
    })

    if (opts.md && opts.md !== "") {
      self.root.innerHTML = marked(opts.md)
    }

    else if (opts.html) {
      self.root.innerHTML = opts.html
    }
});
    
  


// WEBPACK FOOTER //
// ./_src/riot/riot-md.tag